import * as moment from "moment";

import * as actions from "./actiontypes";
import { OhCaseAction } from "./actions";
import { OhCaseDetailModel, OhCaseDetailModelInRedux, OhCaseInRedux } from "./models";

export function ohCases(state: OhCaseInRedux[] = [], action: OhCaseAction): OhCaseInRedux[] {
    switch (action.type) {
        case actions.LOAD_OHCASES_SUCCESS:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        case actions.LOAD_OHCASE_DETAIL_SUCCESS:
            if (!state.find(c => c.id === action.payload.id)) {
                return [ ...state, detailUpdated(action.payload) ];
            }
            return state.map(c => ohCase(c, action));
        default:
            return state;
    }
}

function ohCase(state: OhCaseInRedux, action: OhCaseAction): OhCaseInRedux {
    switch (action.type) {
        case actions.LOAD_OHCASE_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: OhCaseDetailModel, state: Partial<OhCaseInRedux> = {}): OhCaseDetailModelInRedux {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}
